module.exports = __webpack_public_path__ + "images/_/programs/h2whoa/images/characters/apprenticesRowArmsFolded-8d1e0374293625adce385ef4a156323c.png";


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoa/images/characters/apprenticesRowArmsFolded.png
// module id = 2370
// module chunks = 2